module.exports = __webpack_public_path__ + "media/images/logo-367e051f62ca422f3866c5d6e68b17a7.png";